import React from "react";
import {
  ComposedChart,
  Line,
  Area,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import formatNumber from "../../../helpers/formatNumber";

const CustomTooltip = ({ active, payload, label, values, footer }) => {
  if (active && payload && payload.length) {
    const updatedValues = values.map((id) => {
      const obj = payload.filter((el) => el.dataKey === id)?.[0];
      return { name: obj.name, value: obj.value };
    });

    let footerValue = 0;
    footer?.values?.forEach((id) => {
      const obj = payload.filter((el) => el.dataKey === id)?.[0];
      footerValue += obj.value;
    });

    return (
      <div className="chart-tooltip bg-light text-muted">
        <h6>{label}</h6>
        {updatedValues.map((el) => {
          return (
            <>
              <span className="intro">
                {el?.name}: {formatNumber(el?.value?.toFixed(2))}€
              </span>
              <br />
            </>
          );
        })}
        {footer && (
          <>
            <div className="footer-divider" />
            <span className="intro">
              {`${footer.title}: ${formatNumber(footerValue?.toFixed(2))}€`}
            </span>
          </>
        )}
      </div>
    );
  }

  return null;
};

function MyComposedChart({
  data,
  bar,
  line,
  area,
  titleX,
  showTooltip,
  tooltipValues,
  tooltipFooter,
}) {
  return (
    <div className="chart-container">
      <ResponsiveContainer width={"100%"} height="80%">
        <ComposedChart data={data}>
          {titleX && <XAxis dataKey={titleX} />}
          {showTooltip && (
            <Tooltip
              content={
                <CustomTooltip values={tooltipValues} footer={tooltipFooter} />
              }
            />
          )}
          <Legend />
          {area && (
            <Area
              type="monotone"
              dataKey={area?.key}
              fill={area?.color}
              stroke={area?.color}
            />
          )}
          {bar && <Bar dataKey={bar?.key} stackId="one" fill={bar?.color} />}
          {line && (
            <Line type="monotone" dataKey={line?.key} stroke={line?.color} />
          )}
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}

export default MyComposedChart;
